import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productCategoriesApi } from "api/api/productCategoriesApi/productCategoriesApi";
import { GetProductCategoriesResponse } from "api/api/productCategoriesApi/types";

export const getProductCategoryByCategoryId = createAsyncThunk<
  GetProductCategoriesResponse,
  number
>("productCategories/getProductCategoryByCategoryId", async (categoryId, { rejectWithValue }) => {
  try {
    const data = await productCategoriesApi.getProductCategoryByCategoryId(categoryId);
    return data;
  } catch (error: unknown) {
    let message = "Что-то пошло не так... Попробуйте снова";
    if (axios.isAxiosError(error)) {
      console.error("Error while creating category", error.response?.data);
    } else {
      console.error("Error while creating category", error);
    }
    return rejectWithValue(message);
  }
});